import React from 'react'
import Container from '@mui/material/Container'
import { IStrapiSectionOptions } from '../../types/strapi'
import Section from '../../components/section/Section'
import ThemeContainer from '../../components/theme-container/ThemeContainer'
import transformStrapiPadding from '../../utils/transformStrapiPadding'
import MaxWidthContainer from '../../components/max-width-container/MaxWidthContainer'
import { ISectionData } from '../../utils/renderSection'

export interface ISectionLayoutProps {
  options: IStrapiSectionOptions
  children: React.ReactNode
  section?: ISectionData
  disableGutters?: boolean
}

const SectionLayout: React.FC<ISectionLayoutProps> = ({ children, options, section, disableGutters = false }) => {
  const { theme, background, anchor, width, paddingTop, paddingBottom } = options

  return (
    <ThemeContainer theme={theme}>
      <Section background={background} section={section}>
        <Container
          id={anchor || undefined}
          disableGutters={disableGutters}
          sx={{
            ...(disableGutters && {
              paddingLeft: 0,
              paddingRight: 0,
            }),
            paddingTop: transformStrapiPadding(paddingTop),
            paddingBottom: transformStrapiPadding(paddingBottom),
          }}
        >
          <MaxWidthContainer maxWidth={width}>
            {children}
          </MaxWidthContainer>
        </Container>
      </Section>
    </ThemeContainer>
  )
}

export default SectionLayout
